import { render, staticRenderFns } from "./FormaPagamentoList.vue?vue&type=template&id=bff923be&scoped=true"
import script from "./FormaPagamentoList.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoList.vue?vue&type=script&lang=js"
import style0 from "./FormaPagamentoList.vue?vue&type=style&index=0&id=bff923be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff923be",
  null
  
)

export default component.exports